import { collection } from 'firebase/firestore';

import { getFirestore } from 'services/Firebase';

import DocumentCollection from './DocumentCollection';
import type { FolderSchema } from './DocumentFolderTypes';
import DocumentStore from './DocumentStore';
import User from './User';

export default class AdminManager extends DocumentStore {
    users = new DocumentCollection(collection(getFirestore(), 'users'), User);

    constructor(parent: unknown) {
        super(parent);
        this.users.becomeObservable();
    }

    onLoad = async (_data: FolderSchema) => {
        console.log('Loading ');
        await this.users.load();
    };
}
